@if (!isOnboardingShell()) {
  <div class="container">
    <!-- Main Navigation Tabs -->
    <nav class="mb-4">
      <ul class="nav nav-tabs">
        @if (hasAdminRole() || hasTechAdminRole()) {
          <li class="nav-item">
            <a class="nav-link"
              routerLink="/simplify"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: false}">
              Simplify
            </a>
          </li>
        }
        <li class="nav-item">
          <a class="nav-link nav-link-with-icon"
             routerLink="/guardian"
             routerLinkActive="active">
            <i class="evr evr-guardian" aria-hidden="true"></i>
            Guardian
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-with-icon"
             routerLink="/health"
             routerLinkActive="active">
            <i class="evr evr-health" aria-hidden="true"></i>
            Health
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-with-icon"
             routerLink="/coach"
             routerLinkActive="active">
            <i class="evr evr-coach" aria-hidden="true"></i>
            Coach
          </a>
        </li>
        @if (hasAdminRole()) {
          <li class="nav-item">
            <a class="nav-link nav-link-with-icon"
              routerLink="/setup"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: false}">
              <i class="bi bi-gear" aria-hidden="true"></i>
              Setup
            </a>
          </li>
        }
        @if (hasAdminRole()) {
          <li class="nav-item">
            <a class="nav-link"
               routerLink="/review"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: false}">
              Review
            </a>
          </li>
        }
        @if (hasTechAdminRole()) {
          <li class="nav-item">
            <a class="nav-link"
               routerLink="/tech-admin"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: false}">
              TechAdmin
            </a>
          </li>
        }
      </ul>
    </nav>
  </div>
}
